import {handleSelectionOptions} from "./selection.options";
import {isEmpty} from "../helpers/helpers";
import {getDistricts, getCitiesLists} from "@models/district";
import {getCityById} from "../../models/district";


export const getDistrictByIds = (districts, ids) => {
    let result = [];

    if (!isEmpty(districts) && districts.length && !isEmpty(ids)) {

        if (typeof ids === "string") {
            districts.filter(district => {
                if (Number(district.id) === Number(ids)) {
                    result.push(district.name);
                }
            })
        } else if (typeof ids === "object") {
            districts.filter(district => {
                ids.filter(id => {
                    if (Number(district.id) === Number(id)) {
                        result.push(district.name);
                    }
                })
            })
        }

        return result;
    }
};

export const getDistrictOptions = async (city_id) => {

    const selectedCity = await getCityById(city_id);

    if (!isEmpty(selectedCity) && selectedCity.type === 'city') {
        const {districts} = await getDistricts(city_id);
        const items = handleSelectionOptions(districts, 'district');
        const options = items.options;
        return {options, selected_items: items.selected_items};
    }

    return {options: [], selected_items: []};
};

export const districtsSelection = async (city_id) => {

    return new Promise((resolve, reject) => {
        getDistrictOptions(city_id).then(items => {
            resolve({
                options: items.options,
                selected_items: items.selected_items,
            })
        }).catch(err => {
            reject(err)
        })
    })
};

